import { render } from "./DonateView.vue?vue&type=template&id=150998a2"
import script from "./DonateView.vue?vue&type=script&lang=js"
export * from "./DonateView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__